import { render } from "./MonitoringDataList.vue?vue&type=template&id=6f53d58c&scoped=true&ts=true"
import script from "./MonitoringDataList.vue?vue&type=script&lang=ts"
export * from "./MonitoringDataList.vue?vue&type=script&lang=ts"

import "./MonitoringDataList.vue?vue&type=style&index=0&id=6f53d58c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f53d58c"]])

export default __exports__